/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, NotificationEmailSettingsControllerGetNotificationEmailSettingsPathParams, NotificationEmailSettingsControllerGetNotificationEmailSettings400, NotificationEmailSettingsControllerGetNotificationEmailSettings401, NotificationEmailSettingsControllerGetNotificationEmailSettings403, NotificationEmailSettingsControllerGetNotificationEmailSettings404 } from "../../models/notificationEmailSettingsController/NotificationEmailSettingsControllerGetNotificationEmailSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { notificationEmailSettingsControllerGetNotificationEmailSettings } from "../../clients/notification-email-settingsService/notificationEmailSettingsControllerGetNotificationEmailSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const notificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey = (userId: NotificationEmailSettingsControllerGetNotificationEmailSettingsPathParams["userId"]) => [{
  url: '/api/v1/notification-email-settings/:userId',
  params: {
    userId: userId
  }
}] as const;
export type NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey = ReturnType<typeof notificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey>;
export function notificationEmailSettingsControllerGetNotificationEmailSettingsQueryOptions(userId: NotificationEmailSettingsControllerGetNotificationEmailSettingsPathParams["userId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = notificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey(userId);
  return queryOptions<NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, ResponseErrorConfig<NotificationEmailSettingsControllerGetNotificationEmailSettings400 | NotificationEmailSettingsControllerGetNotificationEmailSettings401 | NotificationEmailSettingsControllerGetNotificationEmailSettings403 | NotificationEmailSettingsControllerGetNotificationEmailSettings404>, NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, typeof queryKey>({
    enabled: !!userId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return notificationEmailSettingsControllerGetNotificationEmailSettings(userId, config);
    }
  });
}

/**
 * @description Retrieves the user's notification email settings. Self-only. Auto-creates the row with its default when absent.
 * @summary Get notification email settings
 * {@link /api/v1/notification-email-settings/:userId}
 */
export function useNotificationEmailSettingsControllerGetNotificationEmailSettings<TData = NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, TQueryData = NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, TQueryKey extends QueryKey = NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey>(userId: NotificationEmailSettingsControllerGetNotificationEmailSettingsPathParams["userId"], options: {
  query?: Partial<QueryObserverOptions<NotificationEmailSettingsControllerGetNotificationEmailSettingsQueryResponse, ResponseErrorConfig<NotificationEmailSettingsControllerGetNotificationEmailSettings400 | NotificationEmailSettingsControllerGetNotificationEmailSettings401 | NotificationEmailSettingsControllerGetNotificationEmailSettings403 | NotificationEmailSettingsControllerGetNotificationEmailSettings404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationEmailSettingsControllerGetNotificationEmailSettingsQueryKey(userId);
  const query = useQuery({
    ...notificationEmailSettingsControllerGetNotificationEmailSettingsQueryOptions(userId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationEmailSettingsControllerGetNotificationEmailSettings400 | NotificationEmailSettingsControllerGetNotificationEmailSettings401 | NotificationEmailSettingsControllerGetNotificationEmailSettings403 | NotificationEmailSettingsControllerGetNotificationEmailSettings404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}